import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getJobs } from '../services/api';
import ScoreBar from '../components/ScoreBar';

const EXP_LABELS = {
  'LESS_THAN_6_MONTHS': '< 6 mois', '6_MONTHS_TO_1_YEAR': '6m - 1an',
  '1_TO_2_YEARS': '1-2 ans', '2_TO_3_YEARS': '2-3 ans', '3_TO_4_YEARS': '3-4 ans',
  '4_TO_5_YEARS': '4-5 ans', '5_TO_7_YEARS': '5-7 ans', '7_TO_10_YEARS': '7-10 ans',
  '10_TO_15_YEARS': '10-15 ans', 'MORE_THAN_15_YEARS': '15+ ans',
};

const CONTRACT_LABELS = { 'FULL_TIME': 'CDI', 'PART_TIME': 'Temps partiel', 'INTERNSHIP': 'Stage', 'FREELANCE': 'Freelance' };
const REMOTE_LABELS = { 'no': 'Présentiel', 'partial': 'Hybride', 'fulltime': '100% remote' };

function Jobs() {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    getJobs().then(r => setJobs(r.data)).catch(() => {});
  }, []);

  return (
    <div style={{ padding: 32, maxWidth: 1200, margin: '0 auto' }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, color: '#1e293b', marginBottom: 24 }}>
        Offres d'emploi ({jobs.length})
      </h1>

      <div style={{ display: 'grid', gap: 16 }}>
        {jobs.map(job => (
          <Link to={`/jobs/${job.reference}`} key={job.reference} style={{ textDecoration: 'none' }}>
            <div style={{
              background: '#fff', borderRadius: 12, padding: 24,
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
              transition: 'box-shadow 0.2s, transform 0.2s',
              cursor: 'pointer',
              border: '1px solid #e2e8f0',
            }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'none'; }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', margin: 0 }}>{job.name}</h2>
                  <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
                    {job.contract_type && <Tag>{CONTRACT_LABELS[job.contract_type] || job.contract_type}</Tag>}
                    {job.experience_level && <Tag color="#8b5cf6">{EXP_LABELS[job.experience_level] || job.experience_level}</Tag>}
                    {job.remote && <Tag color="#059669">{REMOTE_LABELS[job.remote] || job.remote}</Tag>}
                  </div>
                </div>
                <div style={{ textAlign: 'right', minWidth: 160 }}>
                  <div style={{ fontSize: 24, fontWeight: 700, color: '#1e293b' }}>{job.candidates_count}</div>
                  <div style={{ fontSize: 13, color: '#64748b' }}>candidat{job.candidates_count !== 1 ? 's' : ''}</div>
                  {job.avg_score && (
                    <div style={{ marginTop: 8 }}>
                      <ScoreBar score={job.avg_score} label="Score moyen" small />
                    </div>
                  )}
                  {job.matchings_count > 0 && (
                    <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>{job.matchings_count} matchings</div>
                  )}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

function Tag({ children, color = '#3b82f6' }) {
  return (
    <span style={{
      background: color + '15', color, fontSize: 12, fontWeight: 500,
      padding: '3px 10px', borderRadius: 999,
    }}>
      {children}
    </span>
  );
}

export default Jobs;
